<form [formGroup]="actionProcessFormGroup" class="d-flex flex-column w-100 gap-4">
    <span class="action-purpose" [class]="actionToProcess().done ? 'done' : 'pending'">
        {{actionToProcess().purpose}}
    </span>
    <div class="d-flex flex-row w-100  align-items-center gap-4">
        <div>
            <span class="input-label">De: </span>
            @if(actionToProcess().demander) {
            <span>{{ actionProcessFormGroup.value.from}}</span>
            }@else {
            <span>Inconnu</span>
            }
        </div>
        <div>
            <span class="input-label">Pour: </span>
            @if(actionToProcess().recipient) {
            <span>{{ actionProcessFormGroup.value.to}}</span>
            }@else {
            <span>Inconnu</span>
            }
        </div>
        <div>
            <span class="input-label">Créée le: </span>
            <span>{{(actionToProcess().createdAt | date: 'EEE dd/MM/yyyy hh:mm') | titlecase}} </span>
            @if(actionToProcess().delayedAnnouncement) {
            <small class="italic">({{actionToProcess().delayedAnnouncement}})</small>

            }
        </div>
    </div>
    <div class="d-flex w-100 gap-4">
        <div class="w-50">
            <label for="subject" class="input-label">Sujet</label>
            <p name="subject">
                {{ actionProcessFormGroup.value.subject}}
            </p>
        </div>
        <div class="w-50">
            <label for="message" class="input-label">Message</label>
            <p name="message">
                {{ actionProcessFormGroup.value.message}}
            </p>
        </div>
    </div>


    @if(actionToProcess().deadline) {
    <div>
        <p-message [severity]="deadlineSeverity()" [text]="deadlineDetail()" [escape]="false"
            [style]="{width:'100%'}"></p-message>
    </div>
    }
    <div class="d-flex flex-column w-100"><label for="answer" class="input-label">Statut*</label>
        <p-dropdown [options]="actionsStatusesOptions()" [appendTo]="'body'" [style]="{width: '100%'}"
            formControlName="status" [disabled]="processingAction()"></p-dropdown>
    </div>
    <div class="d-flex flex-column w-100"><label for="answer" class="input-label">Votre réponse</label>
        <textarea pInputTextarea formControlName="answer" rows="5"></textarea>
    </div>

    <div class="w-100 d-flex justify-content-end gap-4">
        <span>
            <i-button [styleClass]="'blue'" class="ms-auto" text="Enregistrer" [loading]="processingAction()"
                [disabled]="processingAction() || actionProcessFormGroup.invalid"
                (click)="processAction({ validate: false })"></i-button>

        </span>
        <span>
            <i-button [styleClass]="'green'" class="ms-auto" text="Traiter" [loading]="processingAction()"
                [disabled]="processingAction() || actionProcessFormGroup.invalid"
                (click)="processAction({ validate: true } )"></i-button>

        </span>
    </div>
</form>